import React from 'react';
import type { GameMode } from '../game/types';

interface HomeScreenProps {
  onStart: (mode: GameMode) => void;
  onOpenInfo: (type: 'daily' | 'upgrade' | 'leaderboard') => void;
  highScore: number;
}

const bricks = [
  ['12%','7%','-11deg','4.6s'], ['69%','4%','8deg','5.2s'], ['77%','28%','-7deg','4.1s'],
  ['7%','54%','12deg','5.8s'], ['71%','62%','7deg','4.8s'], ['35%','10%','-4deg','5.5s'],
  ['18%','78%','-9deg','4.3s'], ['81%','79%','10deg','5.7s']
];

export function HomeScreen({ onStart, onOpenInfo, highScore }: HomeScreenProps) {
  return (
    <>
      <main className="home">
        <section className="home-copy">
          <div className="eyebrow">VIVA GAME · 第一基础工程</div>
          <h1 className="game-title"><span>弹球砖块</span><span>破坏者1.0</span></h1>
          <p className="tagline">一颗弹球，摧毁整个世界</p>
          <p className="english-title">BRICK BREAKER: BREAKER FORCE</p>
          <p className="intro">这是一版用来检验游戏结构和功能完整性的可运行基础版：包含三关、特殊砖块、道具掉落、升级三选一、每日挑战、本地排行榜、暂停、重开、音效和移动端触控。</p>
          <div className="hero-actions">
            <button className="primary-btn" onClick={() => onStart('normal')}>开始挑战 ▶</button>
            <button className="secondary-btn" onClick={() => onStart('daily')}>今日随机关卡</button>
          </div>
          <div className="home-stats">
            <div className="stat"><strong>3</strong><span>基础关卡</span></div>
            <div className="stat"><strong>4+3</strong><span>砖块种类与强化</span></div>
            <div className="stat"><strong>{highScore.toLocaleString()}</strong><span>本机最高分</span></div>
          </div>
        </section>
        <section className="hero-visual" aria-hidden="true">
          <div className="orbit"><div className="energy-ball" /></div>
          <div className="brick-cloud">
            {bricks.map(([left, top, rotate, duration], index) => (
              <i key={index} className="floating-brick" style={{ left, top, ['--r' as string]: rotate, ['--d' as string]: duration }} />
            ))}
          </div>
          <div className="paddle-art" />
        </section>
      </main>
      <section className="feature-row" aria-label="附加功能">
        <article className="feature-card" onClick={() => onOpenInfo('daily')}>
          <div className="feature-icon">▦</div><div><h3>每日挑战</h3><p>按日期生成固定随机地图，每天刷新一次。</p></div>
        </article>
        <article className="feature-card" onClick={() => onOpenInfo('upgrade')}>
          <div className="feature-icon">◉</div><div><h3>球体升级</h3><p>过关后强化伤害、挡板或复制弹球。</p></div>
        </article>
        <article className="feature-card" onClick={() => onOpenInfo('leaderboard')}>
          <div className="feature-icon">♛</div><div><h3>排行榜</h3><p>本地保存前十成绩，验证分数数据结构。</p></div>
        </article>
      </section>
    </>
  );
}
